import React, { useState } from 'react';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import { PrioritizeEvaluation } from '../../../DRCAssessment';
import {
  type DropDownSelectOption,
  Loading,
  Alert,
  Select,
  Button,
} from '../../../../../components';
import { COMMON_FILTER_TEXT } from '../../../lang';
import { useTableFilterData } from '../../../../Application/graphql';

const SELECT_DEPT_TEXT = 'Please select the department first.';

const emptyNotice = (
  <div className="flex flex-row items-center font-bold italic gap-[1rem] w-full justify-center p-6">
    <AllInboxIcon
      sx={{
        color: '#951d1d',
        fontSize: '3rem',
      }}
    />
    <span className="text-[#951d1d]">{SELECT_DEPT_TEXT}</span>
  </div>
);

const initialPriorityProps = {
  department: '',
  filter: {},
};

export const ViewPriority: React.FunctionComponent = () => {
  const [selectedDept, setSelectedDept] = useState<string>('');
  const [priorityProps, setPriorityProps] = useState<{
    department: string;
    filter: any;
  }>(initialPriorityProps);

  const { departments, loading, error } = useTableFilterData();
  const departmentOptions: DropDownSelectOption[] = (departments as any[]).map(
    department => ({
      value: department.value,
      label: department.label,
    }),
  );

  const applyFilter = (): void => {
    setPriorityProps({
      department: selectedDept,
      filter: {
        programmeChoice: {
          department: {
            eq: selectedDept,
          },
        },
      },
    });
  };

  const clearFilter = (): void => {
    setPriorityProps(initialPriorityProps);
    setSelectedDept('');
  };

  const handleChangeDept = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    setSelectedDept(e.target.value);
  };

  // GS must select at least a department to show the list
  const validDept = Boolean(priorityProps.department);
  const displayPriorityList =
    validDept && Object.keys(priorityProps.filter).length > 0;

  if (error)
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: 'Error Occurs.' + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );

  return loading ? (
    <Loading />
  ) : (
    <>
      <div className="flex flex-row items-center gap-[1rem] bg-[#F1F1F1] py-4 px-6 rounded">
        <span className="font-bold">
          {COMMON_FILTER_TEXT.FILTER_CATEGORY.DEPT}
        </span>
        <Select
          options={departmentOptions}
          value={selectedDept}
          fullWidth
          size="small"
          sx={{
            '.MuiInputBase-root': {
              background: '#ffffff',
            },
          }}
          onChange={handleChangeDept}
        />
        <Button
          variant="contained"
          sx={{
            textTransform: 'none',
          }}
          onClick={applyFilter}
        >
          {COMMON_FILTER_TEXT.APPLY}
        </Button>
        <Button
          variant="outlined"
          sx={{
            textTransform: 'none',
          }}
          onClick={clearFilter}
        >
          {COMMON_FILTER_TEXT.CLEAR}
        </Button>
      </div>
      {displayPriorityList ? (
        <PrioritizeEvaluation viewOnly {...priorityProps} />
      ) : (
        emptyNotice
      )}
    </>
  );
};
